import {styled} from "@mui/material/styles";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import {blue} from "../common/colors";
import TableRow from "@mui/material/TableRow";

export const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: blue,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        fontSize: 'inherit',
        padding: '1em',

    },
    [`&.${tableCellClasses.body}`]: {
        height: "5em",
        fontSize: 'inherit',
        color: 'inherit',
        padding: '1em',
        flex: 1,
    },
}));

export const StyledTableRow = styled(TableRow)(({theme}) => ({
    textDecoration: 'none',
    '&:hover': {
        backgroundColor: 'rgba(77, 187, 219, 0.2) !important',
        cursor: 'pointer',
    },
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
